import { apiRequest } from "./client";

export interface AppConfig {
  coupleNames: string;
  weddingDate: string;
  slideshowIntervalSeconds: number;
  galleryPollIntervalSeconds: number;
  guestPageReloadIntervalSeconds: number;
  adminPollIntervalSeconds: number;
  kioskReloadIntervalSeconds: number;
  kioskVideoMaxSeconds: number;
  kioskGuestbookIntervalSeconds: number;
  kioskGuestbookMaxPerRound: number;
  kioskGuestbookSeconds: number;
  maxUploadSizeMb: number;
  uploadsPaused: boolean;
  // Change-tokens bumped by the admin Maintenance menu; -1 = not fetched yet.
  kioskReloadToken: number;
  guestReloadToken: number;
}

export function fetchConfig(): Promise<AppConfig> {
  return apiRequest<AppConfig>("/api/config");
}
